<template>
  <p class="preorder-dispatch-line">
    <span class="preorder-dispatch-line__label">Pre-Order</span>
    <button
      type="button"
      class="preorder-dispatch-line__trigger"
      aria-label="Learn more about pre-order"
      @click="openPreorderInfo"
    >
      <span class="preorder-dispatch-line__icon" aria-hidden="true">?</span>
    </button>
    <span v-if="dispatchText" class="preorder-dispatch-line__dispatch">
      {{ dispatchText }}
    </span>
  </p>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "PreorderDispatchLine",
  props: {
    dispatchDate: {
      type: String,
      default: null,
    },
    fallbackText: {
      type: String,
      default: null,
    },
  },
  computed: {
    dispatchText() {
      if (this.dispatchDate) {
        return `Expected Dispatch: ${this.dispatchDate}`;
      }

      return this.fallbackText;
    },
  },
  methods: {
    ...mapActions("product", ["openPreorderModal"]),
    openPreorderInfo() {
      this.openPreorderModal();
    },
  },
};
</script>

<style lang="scss" scoped>
.preorder-dispatch-line {
  @include editorial-body(14px);
  color: #5f8e5c;
  margin: 0 0 5px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;

  &__label,
  &__dispatch {
    font-style: normal;
  }

  &__trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    line-height: 0;
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border: 1px solid #3b5839;
    border-radius: 50%;
    color: #3b5839;
    @include editorial-body(11px);
    font-style: normal;
    line-height: 1;
  }
}
</style>
